import { Backdrop, CircularProgress } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const BackDrop = (props: { isModalOpen: boolean }) => {
  const { classes } = useStyles();
  const { isModalOpen } = props;
  return (
    <Backdrop className={classes.backdrop} open={isModalOpen}>
      <CircularProgress id="progress-bar" />
    </Backdrop>
  );
};

export default BackDrop;
